import '../../assets/index.less'

const AgreementDelete = () => {
  document.title = '注销规则'
  return (
    <div className="page agreement">
      <div className="main">
        <img className="logo" src={require('../../assets/logo.png')} alt="" />
        <div className="h1">注销规则</div>
        <div className="p">版本更新日期：2022年6月20日</div>
        <div className="p">版本生效日期：2022年6月20日</div>

        <div className="h3">尊敬的用户：</div>
        <div className="p">
          当您点击“确定注销”视为您阅读并同意本《注销规则》及相关条款，即表示您已充分阅读、理解并接受本《注销规则》的全部内容。请您务必审慎阅读、充分理解各条款内容，特别是涉及您重大权益的条款，特别是免除或者限制商汤责任的条款、限制用户权利的条款等。前述条款可能以加粗、加下划线等形式提示您注意本规则内容中以加粗方式显著标识的条款，请您着重阅读。阅读本《注销规则》的过程中，如果您不同意相关任何条款和条件约定，请您立即停止账号注销程序。
        </div>
        <div className="p">
          1、如您申请注销即表示您自愿放弃账号内所有用户权益和虚拟资产（包括但不限于棋手数据、对弈记录、优惠券及虚拟物品等）。
        </div>
        <div className="p">
          2、本账号一旦被注销，您的账号内的全部数据将不可检索、访问、恢复，请您在操作之前自行备份账户相关的所有信息和数据。请您保存好订购服务的交易凭证（如有）、证书信息（如有）等资料，否则由此带来的不利后果及损失由您自行承担，商汤无需承担任何责任。
        </div>
        <div className="p">
          3、注销本账号后，您将无法再使用本账号，也将无法找回您账号中及与账户相关的任何内容或信息。
        </div>
        <div className="p">
          4、注销本账号并不代表本账号注销前的账号行为和相关责任得到豁免或减轻。
        </div>
      </div>
    </div>
  )
}

export default AgreementDelete
